/**
 * @param name
 * @returns {boolean}
 */
export function hasAtLeastOneLetter(name) {
    return /[a-zA-Z]/.test(name);
}
